import { ValidationError } from "sequelize"
import {
    MarkovVariable,
    MarkovVariableCreate,
    MarkovVariableSave,
    MarkovDatasetVariableExpression,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    MarkovVariableList,
    MarkovVariableListByName,
    MarkovVariableValidation,
    MarkovVariableFilters,
} from "../types"
import {
    LoadAllMarkovDatasetVariableExpressions,
    LoadMarkovDatasetVariableExpressionById,
    SaveMarkovDatasetVariableExpression,
} from "./datasetExpressions"


export const LoadAllMarkovVariables = (modelId: number, datasetId: number) => (
    GET(`/markovVariable/modelId/${modelId}`)
    .then((variables: MarkovVariable[]) => (
        LoadAllMarkovDatasetVariableExpressions(datasetId)
        .then((expressionList) => {
            const variableList: MarkovVariableList = {}
            const variableListByName: MarkovVariableListByName = {}

            variables.forEach((variable) => {
                const variableWithExpression: MarkovVariable = {
                    ...variable,
                    expression: expressionList[variable.id] || "",
                }
                variableList[variable.id] = variableWithExpression
                variableListByName[variable.name] = variableWithExpression
            })

            return { variableList, variableListByName }
        })
    ))
)

export const LoadMarkovVariableById = (variableId: number, modelId: number, datasetId: number) => (
    GET(`/markovVariable/id/${variableId}/modelId/${modelId}`)
    .then((variable: MarkovVariable) => (
        LoadMarkovDatasetVariableExpressionById(variableId, datasetId)
        .then((expression) => {
            if (variable) {
                const variableWithExpression: MarkovVariable = {
                    ...variable,
                    expression: expression && expression.expression,
                }
                return variableWithExpression
            }
            return null
        })
    ))
)

export const SaveMarkovVariable = (
    id: number,
    variable: MarkovVariableCreate,
    expression: MarkovDatasetVariableExpression,
    lang: LangType,
) => {
    const variableData: MarkovVariableSave = {
        id,
        variable,
    }
    return POST(
        "/markovVariable/save",
        JSON.stringify(variableData),
    ).then((res1) => {
        const newVariable = res1 as MarkovVariable
        const error = res1 as ValidationError

        const newVariableId = newVariable.id || null
        const validation = <MarkovVariableValidation>validate(error, lang)

        if (validation) {
            return {
                newVariableId,
                validation,
            }
        }

        const expressionData: MarkovDatasetVariableExpression = {
            ...expression,
            variableId: newVariableId || id,
        }
        return SaveMarkovDatasetVariableExpression(expressionData, lang)
        .then((res2) => {
            const expressionValidation: MarkovVariableValidation = res2 && res2.expression ? { expression: res2.expression } : null
            return {
                newVariableId,
                validation: expressionValidation,
            }
        })
    })
}

export const DeleteMarkovVariable = (variableId: number, modelId: number) => (
    DELETE(`/markovVariable/delete/${variableId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)

export const SortMarkovVariables = (
    variables: MarkovVariable[],
    sortColumn: keyof MarkovVariable,
    sortOrder: OrderType,
    filters: MarkovVariableFilters,
) => {
    const variablesFiltered = variables.filter((variable) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, variable)
        return showRow
    })
    variablesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const variableIds: number[] = []
    variablesFiltered.forEach((variable) => variableIds.push(variable.id))

    return variableIds
}
